import SkapaRadioButtonGroup, {
  type RadioButtonGroupProps,
} from "@ingka/radio-button-group";

export const RadioButtonGroup = (props: RadioButtonGroupProps) => {
  return <SkapaRadioButtonGroup prefix="saleslead__" {...props} />;
};
